//
// Initialize product customizer
//
$(document).ready(function () {
  //
  // Listen for messages from iframe
  //
  window.addEventListener(
    'message',
    (event) => {
      //Ensure message is from iframe
      if (event.origin === 'https://editor.marketdwellings.com') {
        if (event?.data === 'cancel') {
          //Handle cancel message
          var customizationSection = $('#product_customization');
          var productSection = $('.page-content--product');
          var productBlocks = $('.product-block--tab');
          var reviewsSection = $('#judgeme_product_reviews');
          var productRecommendationsSection = $('.index-section--sub-product');
          customizationSection.fadeOut();
          productSection.fadeIn();
          productBlocks.fadeIn();
          reviewsSection.fadeIn();
          productRecommendationsSection.fadeIn();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          customizationSection.empty();
        } else if (event?.data === 'contact-us') {
          //Handle contact-us message
          Beacon('open');
        } else if (event?.data === 'frame-initialized') {
          //Frame initialized, send customization configuration object to complete initialization
          var currentVariantId = $('#variant__id').text();
          var variantCustomizationConfig = $(`.variant__customization_config[variantId="${currentVariantId}"]`).text();
          var productCustomizationConfig = $('#product__customization_config').text();
          if (variantCustomizationConfig) {
            const customizationConfig = withCustomerContext(JSON.parse(variantCustomizationConfig));
            document.getElementById('product-customization-frame').contentWindow.postMessage(customizationConfig, '*');
          } else if (productCustomizationConfig) {
            //Product level customization configuration present
            const customizationConfig = withCustomerContext(JSON.parse(productCustomizationConfig));
            document.getElementById('product-customization-frame').contentWindow.postMessage(customizationConfig, '*');
          } else {
            //No customization configuration defined
            var variantColor = $('[data-variant-color-label]').text() ? $('[data-variant-color-label]').text().trim() : null;
            const editorConfig = buildEditorConfig($('#product__sku').text(), $('#customization_rollup_template').text(), variantColor);
            document.getElementById('product-customization-frame').contentWindow.postMessage(editorConfig, '*');
          }
        } else if (event?.data?.type === 'single-customization') {
          var mdProductForm = $('.md-cart-form');
          mdProductForm.append(`<input type="hidden" name="properties[Customization ID]" value="${event?.data?.customization}" />`);
          mdProductForm.append(`<input type="hidden" name="properties[_Mockup]" value="${event?.data?.mockupName}" />`);
          mdProductForm.append(`<input type="hidden" name="properties[_Mockup Url]" value="${event?.data?.mockupUrl}" />`);
          if (event?.data?.dhCookie) {
            mdProductForm.append(`<input type="hidden" name="properties[_DHcookie]" value="${event?.data?.dhCookie}" />`);
          }
          mdProductForm.submit();
        } else if (event?.data?.type === 'bundle-customization') {
          var mdProductForm = $('.md-cart-form');
          mdProductForm.append(`<input type="hidden" name="properties[Bundle ID]" value="${event?.data?.bundle}" />`);
          mdProductForm.append(`<input type="hidden" name="properties[_Mockup]" value="${event?.data?.mockupName}" />`);
          mdProductForm.append(`<input type="hidden" name="properties[_Mockup Url]" value="${event?.data?.mockupUrl}" />`);
          if (event?.data?.dhCookie) {
            mdProductForm.append(`<input type="hidden" name="properties[_DHcookie]" value="${event?.data?.dhCookie}" />`);
          }
          mdProductForm.submit();
        }
      }
    },
    false
  );

  //
  // Add customer context to customization configuration object
  //
  const withCustomerContext = (customizationConfiguration) => {
    var customerEmail = $('#customer__email').text();
    if (customerEmail) {
      customizationConfiguration.email = customerEmail;
    }

    var customerName = $('#customer__name').text();
    if (customerName) {
      customizationConfiguration.customerName = customerName;
    }

    var customerPhone = $('#customer__phone').text();
    if (customerPhone) {
      if (customerPhone.length == 12 && customerPhone.charAt(0) == '+') {
        customerPhone = `${customerPhone.substring(2, 5)}.${customerPhone.substring(5, 8)}.${customerPhone.substring(8)}`;
      }
      customizationConfiguration.customerPhone = customerPhone;
    }
    return customizationConfiguration;
  };

  //
  // Build editor configuration for item
  //
  const buildEditorConfig = (sku, rollupTemplate, paperColor) => {
    let editorConfig = {
      type: 'basic',
      template: sku,
      rollup: rollupTemplate,
      color: paperColor,
    };
    return withCustomerContext(editorConfig);
  };

  //
  // Handle customization button click
  //
  $(document).on('click', '.btn--customize', function () {
    if (isMobileOrTabletBrowser()) {
      var currentVariantId = $('#variant__id').text();
      var currentQuantity = $('[name="quantity"]').val();
      var variantCustomizationConfig = $(`.variant__customization_config[variantId="${currentVariantId}"]`).text();
      var productCustomizationConfig = $('#product__customization_config').text();
      if (variantCustomizationConfig) {
        const customizationConfig = withCustomerContext(JSON.parse(variantCustomizationConfig));
        window.location.assign(`https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com')}&variantId=${currentVariantId}&quantity=${currentQuantity}&config=${encodeURIComponent(JSON.stringify(customizationConfig))}`);
      } else if (productCustomizationConfig) {
        //Product level customization configuration present
        const customizationConfig = withCustomerContext(JSON.parse(productCustomizationConfig));
        window.location.assign(`https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com')}&variantId=${currentVariantId}&quantity=${currentQuantity}&config=${encodeURIComponent(JSON.stringify(customizationConfig))}`);
      } else {
        //No customization configuration defined
        var variantColor = $('[data-variant-color-label]').text() ? $('[data-variant-color-label]').text().trim() : null;
        const editorConfig = buildEditorConfig($('#product__sku').text(), $('#customization_rollup_template').text(), variantColor);
        window.location.assign(`https://editor.marketdwellings.com/editor?mobile=true&callbackUri=${encodeURI('https://marketdwellings.com')}&variantId=${currentVariantId}&quantity=${currentQuantity}&config=${encodeURIComponent(JSON.stringify(editorConfig))}`);
      }
    } else {
      var customizationSection = $('#product_customization');
      customizationSection.empty();
      var iframeUrl = `https://editor.marketdwellings.com/editor`;
      customizationSection.append(`<iframe id="product-customization-frame" src="${iframeUrl}" title="Product Customization" style="border:none;height:85vh;width:100%;" allow="clipboard-read; clipboard-write"></iframe>`);
      var productSection = $('.page-content--product');
      var productBlocks = $('.product-block--tab');
      var reviewsSection = $('#judgeme_product_reviews');
      var productRecommendationsSection = $('.index-section--sub-product');
      productSection.fadeOut();
      productBlocks.fadeOut();
      reviewsSection.fadeOut();
      productRecommendationsSection.fadeOut();
      customizationSection.fadeIn();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  //
  // Check if browser is mobile or tablet
  //
  function isMobileOrTabletBrowser() {
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
  
  document.addEventListener("submit", function (e) {
    const form = e.target;

    if (!form.classList.contains("md-cart-form")) return;

    const active = document.activeElement;

    // if (
    //   active &&
    //   active.matches('input[name="quantity"]')
    // ) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();
    // }
  }, true); 

});
